import React, { useEffect, useRef, useState } from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../../../misc/constants';
import { BaseConfig } from '../../../BaseConfig';
import PopUp1 from '../../../general/pop-up1';

import "./reference-materials-window.css"
import { AnimationPage } from '../../../../cvp-webgames-core/UI/Animation/animation-page';
import { getGlobalTextSizeStyle, getSaveData, setFocus, TextHtmlTagType } from '../../../../misc/tools';
import { FontSizeMultiplier } from '../../../../cvp-webgames-core/Misc/interfaces';

class ReferenceMaterialsWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'return1',
				src: process.env.PUBLIC_URL + '/assets/images/return1.svg'
			}
		];
	}
}

const referenceMaterials = [{
	prevImg: process.env.PUBLIC_URL + '/assets/images/main-menu/reference-materials/pdf1.jpg',
	title: 'Decision Support Tool.',
	description: 'The Decision Support Tool provides an unrivalled range of technical, financial, risk and strategy optimization software to rapidly evaluate options and identify the optimal cost/risk/performance/life cycle value.   DST consisting of 7 modules that cover over 40 decision types, ranging from asset investments to optimal operations, maintenance, shutdowns, spares, upgrades, replacements, obsolescence, disposal and total portfolio, total life cycle management.  ',
	src: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-jcdst-deliverables/gold-08-31-2023/accessible-just-culture-decision-support-tool.pdf'
}/*, {
	prevImg: process.env.PUBLIC_URL + '/assets/images/main-menu/reference-materials/pdf2.jpg',
	title: 'Vortex Approach to airway management - ANZCA Blue Book 2019',
	description: 'While technical competence and adequate planning are crucial to effective airway management, it is well recognised that even well-prepared airway clinicians can...',
	src: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-daarc-calm-medsurg-2022/daarc-pdfs/vortex-approach-to-airway-management-anzca-blue-book-2019.pdf'
}, {
	prevImg: process.env.PUBLIC_URL + '/assets/images/main-menu/reference-materials/pdf3.jpg',
	title: '2022 ASA Practice Guidelines for Management of the Difficult Airway',
	description: 'Practice guidelines are systematically developed recommendations that assist the practitioner and patient in making decisions about health care.',
	src: 'http://cdn.sabercity.com.s3.amazonaws.com/segs-sharefolder/segs-daarc-calm-medsurg-2022/daarc-pdfs/2022-asa-practice-guidelines-for-management-of-the-difficult-airway.pdf'
}*/]

export const referenceMaterialsWindowCaching = new ReferenceMaterialsWindowCaching();

const ReferenceMaterialsWindow = (props: ReferenceMaterialsWindowConfig) => {
	const root = useRef(null);
	const savedData = getSaveData();
	var mapHeight = 0;
	switch (savedData.fontSizeMultiplier) {
		case FontSizeMultiplier.small:
			mapHeight = 400;
			break;
		case FontSizeMultiplier.med:
			mapHeight = 800;
			break;
		case FontSizeMultiplier.big:
			mapHeight = 1200;
			break
	}
	
	const [focusSet, setFocusSet] = useState(false);
	if(!focusSet) {
		setTimeout(() => {
			setFocus('reference-window-top');
		}, 1000);
		setFocusSet(true);
	}
	useEffect(() => {
		props.animation.updateProps({
			page: root.current
		});
	}, [root])
	return (
		<div id='reference-window-top' tabIndex={0} ref={root} className={"modal-disable-select center-element reference-materials-window-container " + props.animation.getInitialClass()} style={{
		}}>
			<PopUp1
				title={constants.projectTitle}
				buttons={[{
					imgSrc: referenceMaterialsWindowCaching.getItemByKey('return1').src,
					alt508: '',
					width: '483px',
					height: '80px',
					buttonText: "Return to Main Menu",
					hoverColor: '#bfddff',
					bgColor: undefined,
					onClick: props.onReturnToMainMenu
				}]}
				onRenderContent={() => {
					return (
						<div style={{ width: '100%', height: '570px', position: 'relative', top: '0', left: '0px' }}>
							<div style={{ margin: '20px', position: 'absolute', left: '0px', top: '0px', width: '97%', height: '540px' }} className='main-content-inner'>
								<div style={{
									marginLeft: '20px',
									marginTop: '20px',
									marginRight: '20px',
									marginBottom: '20px',
									overflow: 'auto',
									height: '498px'
								}}>
									<div>
										<p className='default-text center-element-horizontal white-text' style={{
											textAlign:'center',
											width: '100%',
											...getGlobalTextSizeStyle(TextHtmlTagType.p)
										}}>
											<span className='title-text2 black-text'>Reference Materials</span><br />
											<span>&nbsp;</span>
										</p>
									</div>

									{referenceMaterials.map((item: any, indx: number) => {

										return (
											<div style={{ position: 'relative', width: '100%', minHeight: '350px' }}>
												<div style={{ width: '50%', position: 'absolute', left: '0px', top: '15px' }}>
													<img src={item.prevImg} aria-label={item.title} alt={item.title + ' - Open the PDF to see more.'} />
												</div>
												<div style={{ width: '48%', position: 'relative', left: '570px', paddingBottom: '20px' }}>
													<h1 className="title-text" style={{ color: 'black', textAlign: 'left', marginRight: '15px', ...getGlobalTextSizeStyle(TextHtmlTagType.h1) }}>{item.title}</h1>
													<br />
													<p className="title-text" style={{ color: 'black', textAlign: 'left', marginRight: '15px', ...getGlobalTextSizeStyle(TextHtmlTagType.p) }}>{item.description}</p>
													<br />
													<a tabIndex={-1} aria-label="Tap to open PDF here" href={item.src} target="_blank">
														<button className="reference-materials-window-button-text small-text">Tap to open PDF here</button>
													</a>
												</div>
											</div>
										)
									})}
								</div>
								
							</div>
						</div>
					);
				}}></PopUp1>
		</div>
	);

};

export interface ReferenceMaterialsWindowConfig extends BaseConfig {
	onReturnToMainMenu: () => void;
	animation: AnimationPage;
}

export default ReferenceMaterialsWindow;